import UIFetchService from '../Service/UIFetchService';
import auth from '../Service/AuthFetchService';

import { ChartBundle, DataPreviewModal, Charts } from './VisualizationCharts';
import React from 'react';
import { Row, Col, message, Modal, Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { isEmpty, isNotEmpty, isTimeFormat, dateFormat, ifEmpty } from '../Service/Utils';
import moment from 'moment';
import 'moment/locale/zh-cn';

class VisualizationReleaseView extends React.Component {
    constructor() {
        super();
        this.state = {
            rows: [],
            dataSources: [],
            md: {},
            dataPreviewModal: {
                visible: false,
                chart: {},
                title: '数据预览'
            },
        };

        this.chartUniqueKey = 0;
        this.jobPollingTimers = {};
        this.dataSources = [];
    }

    // isSelected
    // readOnly
    // onClick()
    // onDelete()
    // onShowParams()
    // onRefresh()
    // onParamChanage(name, value)
    // placeholders
    // chart
    // provided
    render() {
        return <>
            <Row justify='center'>
                <Col>
                    <h2 style={{ margin: '0px' }}>{this.state.name}</h2>
                </Col>
            </Row>
            <Row justify='center'>
                <Col>
                    <span style={{ fontSize: 8, color: 'gray' }}>{this.state.desc}</span>
                </Col>
            </Row>
            <Row 
                id='frameLayout' 
                sider={50}
                style={{width: '100%'}}>
                {this.state.rows.map(chart => <Col flex={`${chart.widthInColumns * 25}%`}>
                    <ChartBundle
                        chart={chart}
                        md={this.state.md}
                        isSelected={false}
                        readOnly={true}
                        placeholders={this.findPlaceholders(chart.templateId)}
                        clientWidth={document.body.clientWidth}
                        onShowParams={() => this.setState(({ rows }) => {
                            if (chart.showParams) {
                                chart.showParams = false;
                            } else {
                                chart.showParams = true;
                            }
                            return { rows };
                        })}
                        onShowDownloadModal={() => this.setState(({ dataPreviewModal }) => {
                            dataPreviewModal.visible = true;
                            dataPreviewModal.mappedProjection = this.mappedProjection;
                            dataPreviewModal.chart = chart;
                            return { dataPreviewModal };
                        })}
                        onParamChanage={(name, value, force) => this.setState(({ rows }) => {
                            chart.params[name] = value;
                            //console.log(force);
                            if (force) {
                                this.doRefresh(chart);
                            }
                            return { rows };
                        })}
                        onRefresh={() => this.doRefresh(chart, true)}
                    />
                </Col>)}
            </Row>
            <Modal
                visible={this.state.tipsModalVisible}
                title='tips'
                closable
                onOk={() => {
                    this.setState({ tipsModalVisible: false });
                    localStorage.setItem('queryGuide.visualization.tips', 'false');
                }}
                okText='我知道了'
                onCancel={() => this.setState({ tipsModalVisible: false })}
                cancelText='关闭'
            >
                <Row>
                    <Col>
                        <span>
                            点击图表右上角的
                            <Button type='link' size='small' icon={<DownOutlined />}></Button>
                            按钮，可以展开更多的过滤条件。
                        </span>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <span>修改图表过滤条件，将会导致数据立即刷新，这个过程可能需要较长时间。</span>
                    </Col>
                </Row>
            </Modal>
            {this.state.dataPreviewModal.visible && <DataPreviewModal
                {...this.state.dataPreviewModal}

                onClose={() => this.setState(({ dataPreviewModal }) => {
                    dataPreviewModal.visible = false;
                    return { dataPreviewModal };
                })}
            />}
        </>;
    }

    doRefresh(chart, force) {
        if (chart.updating) {
            clearInterval(this.jobPollingTimers[chart.key]);
            this.setState(({ rows }) => {
                chart.updating = false;
                chart.fatal = false;
                return { rows };
            });
        } else {
            this.onRefresh(chart, force);
        }
    }

    async componentDidMount() {
        this.allProjection = [];
        this.mappedProjection = {};

        UIFetchService.get('/api/v1/metadata/provinces/tree').then(provinces =>
            this.setState(({ md }) => {
                md.provinces = provinces;
                return { md };
            }));
        UIFetchService.get('/api/v1/metadata/word_books/tree').then(bookCategories =>
            this.setState(({ md }) => {
                md.bookCategories = bookCategories;
                return { md };
            }));
        UIFetchService.get('/api/v1/metadata/ad/to_groups_to_objects').then(toGroupsToObjects =>
            this.setState(({ md }) => {
                md.toGroupsToObjects = toGroupsToObjects;
                return { md };
            }));
        UIFetchService.get('/api/v1/metadata/ad/ad_resource_slots').then(adSlots =>
            this.setState(({ md }) => {
                md.adSlots = adSlots;
                return { md };
            }));

        const processProjections = (items, templateId) => {
            for (let item of items) {
                const ds = this.mappedProjection[templateId];
                if (ds === undefined) {
                    continue;
                }
                if (item.name.startsWith('c:')) {
                    item.key = item.name;
                } else {
                    const pj = ds[item.name];
                    if (pj === undefined) {
                        continue;
                    }
                    item.key = pj.key;
                }
            }
        }
        const rs = await UIFetchService.get(`/api/v1/querying_guide/visualization/${this.props.vid}`);
        for (const chart of rs.rows) {
            chart.key = (this.chartUniqueKey++).toString();
            chart.data = {};
            chart.params = {};
            processProjections(chart.dimensions, chart.templateId);
            processProjections(chart.indicators, chart.templateId);
            processProjections(chart.legends, chart.templateId);
        }
        

        const dataSources = await UIFetchService.post('/api/v1/querying_guide/templates/specified', 
            rs.rows.map(row=>row.templateId));
        let key = 0;
        for (let ds of dataSources) {
            this.mappedProjection[ds.id] = {}
            for (let item of ds.dimensions) {
                item.key = (key++).toString();
                this.allProjection.push(item);
                this.mappedProjection[ds.id][item.name] = item;
            }
            for (let item of ds.indicators) {
                item.key = (key++).toString();
                this.allProjection.push(item);
                this.mappedProjection[ds.id][item.name] = item;
            }
        }
        //this.setState({ dataSources });
        this.dataSources = dataSources;
        console.log('set', this.dataSources);
        for (const chart of rs.rows) {
            this.onRefresh(chart);
        }
        this.setState(rs);

        const showTips = localStorage.getItem('queryGuide.visualization.tips');
        if (isEmpty(showTips) || showTips === 'true') {
            this.setState({ tipsModalVisible: true });
        }

        auth.appendLog(`天机可视化-查看模版:${this.state.name}`);
    }

    findPlaceholders(templateId) {
        if (!(templateId > 0)) {
            return [];
        }
        //console.log('find', this.dataSources);
        const ds = this.dataSources?.find(ds => ds.id === templateId);
        if (isEmpty(ds)) {
            return [];
        }
        return ds.placeholders;
    }

    async onRefresh(chart, force) {
        if (!(chart.templateId > 0)) {
            return;
        }
        if (chart.chartKind !== 'CARD_CHART' && chart.dimensions.length + chart.legends.length === 0) {
            message.error('没有选择任何维度！');
            return;
        }
        if (chart.indicators.length === 0) {
            message.error('没有选择任何指标！');
            return;
        }

        const re = /^\${dt-(\d+)}$/;
        const placeholders = this.findPlaceholders(chart.templateId);
        for (let param of placeholders) {
            if (isEmpty(chart.params[param.name])) {
                if (isEmpty(param.column) && isEmpty(chart.defaultParams[param.name])) {
                    message.error(`参数: ${param.name} 不能为空`);
                    return;
                }

                const defVal = chart.defaultParams[param.name];
                if (isEmpty(defVal)) {
                    continue;
                }
                if (isTimeFormat(param.format)) {
                    if (defVal instanceof Array) {
                        const vals = ['', ''];
                        let m = ifEmpty(defVal[0], '').trim().match(re);
                        if (m != null) {
                            vals[0] = moment().subtract(m[1], 'days').format(dateFormat);
                        } else {
                            vals[0] = defVal[0];
                        }
                        m = ifEmpty(defVal[1], '').trim().match(re);
                        if (m != null) {
                            vals[1] = moment().subtract(m[1], 'days').format(dateFormat);
                        } else {
                            vals[1] = defVal[1];
                        }
                        chart.params[param.name] = vals;
                    } else {
                        const m = defVal.trim().match(re);
                        if (m !== null) {
                            chart.params[param.name] = moment().subtract(m[1], 'days').format(dateFormat);
                        } else {
                            chart.params[param.name] = defVal;
                        }
                    }
                } else {
                    chart.params[param.name] = defVal;
                }
            }
        }

        this.setState(({ rows }) => {
            chart.updating = true;
            chart.fakePercent = 0.0;
            return { rows };
        });

        const params = {
            placeholders: {},
            dimensions: [],/*chart.dimensions.map(d => d.name),*/
            indicators: chart.indicators.filter(d=>!d.name.startsWith('c:')).map(d => d.name),
        };
        chart.indicators
            .filter(d=>d.name.startsWith('c:'))
            .map(d=>chart.calculating.find(calc=>calc.key === d.name))
            .filter(calc=>calc!==undefined)
            .forEach(calc=>{
                for (const node of calc.expression) {
                    if (isNotEmpty(node.name)) {
                        params.indicators.push(node.name);
                    }
                }
            });
        if (Charts.isTable(chart) || Charts.isTreeMap(chart)) {
            for (const f of chart.dimensions) {
                params.dimensions.push(f.name);
            }
            for (const f of chart.legends) {
                params.dimensions.push(f.name);
            }
        } else {
            if (chart.dimensions.length > 0) {
                params.dimensions.push(chart.dimensions[0].name);
            }
            if (chart.legends.length > 0) {
                params.dimensions.push(chart.legends[0].name);
            }
        }
        //for (let d of chart.legends) { params.dimensions.push(d.name); }
        for (let key of Object.keys(chart.params)) {
            const val = chart.params[key];
            if (val instanceof Array) {
                params.placeholders[key] = val.join(',');
            } else {
                params.placeholders[key] = val;
            }
        }
        const query = force ? '?force=true' : '';
        const url = `/api/v1/querying_guide/visualization/${this.props.vid}/charts/${chart.id}/post_running_by_names${query}`;
        const rs = await UIFetchService.post(url, params);
        if (!rs) {
            this.setState(({ rows }) => {
                chart.updating = false;
                chart.fatal = true;
                return { rows };
            });
            return;
        }
        if (rs.cached) {
            const data = await UIFetchService.get(`/api/v1/querying_guide/jobs/${rs.jobId}/all_result`);
            this.setState(({ rows }) => {
                chart.updating = false;
                chart.fatal = false;
                
                Charts.processRows(chart, data, name => {
                    if (name.startsWith('c:')) {
                        const item = chart.calculating.find(cal => cal.key === name);
                        return ifEmpty(item.desc, name);
                    } else {
                        const proj = this.mappedProjection[chart.templateId][name];
                        return proj === undefined ? name : proj.desc;
                    }
                });
                return { rows };
            });
        } else {
            this.beginPolling(chart, rs.jobId, rs.estimatedCostSeconds);
        }
    }

    beginPolling(chart, jobId, estimatedCostSeconds) {
        const fakeIncrement = 100 / estimatedCostSeconds;
        this.jobPollingTimers[chart.key] = setInterval(async () => {
            const status = await UIFetchService.get(`/api/v1/querying_guide/jobs/${jobId}/status`);
            switch (status.status) {
                case 'INIT':
                case 'RUNNING':
                    this.setState(({ rows }) => {
                        if (chart.fakePercent < 99) {
                            chart.fakePercent += fakeIncrement;
                        }
                        if (chart.fakePercent > 99) {
                            chart.fakePercent = 99;
                        }
                        return { rows };
                    })
                    break;
                case 'FAIL':
                    message.error(`执行失败：${status.logs}`);
                    clearInterval(this.jobPollingTimers[chart.key]);
                    this.setState(({ rows }) => {
                        chart.updating = false;
                        chart.fatal = status.logs;
                        return { rows };
                    });
                    break;
                case 'OK':
                    clearInterval(this.jobPollingTimers[chart.key]);
                    const data = await UIFetchService.get(`/api/v1/querying_guide/jobs/${jobId}/all_result`);
                    this.setState(({ rows }) => {
                        chart.updating = false;
                        chart.fatal = false;
                        Charts.processRows(chart, data, name => {
                            if (name.startsWith('c:')) {
                                const item = chart.calculating.find(cal => cal.key === name);
                                return ifEmpty(item.desc, name);
                            } else {
                                return ifEmpty(this.mappedProjection[chart.templateId][name].desc, name);
                            }
                        });
                        return { rows };
                    });
                    break;
                default:
                    break;
            }
        }, 2000);
    }
}

export default VisualizationReleaseView;